import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const cleanObservationForm = async (id: number) => {
	const url = `/observations/admin/forms/${id}/clean/`;

	const response = await cmsClient.put(url);
	return response.data;
};

const useCleanObservationForm = () => {
	const mutation = useMutation(cleanObservationForm);

	return mutation;
};

export default useCleanObservationForm;
